import type {DiffEntry} from '@github-ui/diff-lines/types'

// move this back into files-mock-data when we have real diff data
// this is only moved here to fix a circular dependency
export function getDiffsPageData(): DiffEntry[] {
  const mockDiff: DiffEntry = {
    diffLines: [
      {
        type: 'HUNK',
        blobLineNumber: 21,
        text: '@@ -22,7 +22,7 @@ class RootComponent < ApplicationComponent',
        html: '@@ -22,7 +22,7 @@ class RootComponent &lt; ApplicationComponent',
        position: 0,
        left: 21,
        right: 21,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 22,
        text: ' ',
        // eslint-disable-next-line github/unescaped-html-literal
        html: '<br>',
        position: 1,
        left: 22,
        right: 22,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 23,
        text: '       # The parent component for a file tree, which builds a tree representation',
        html: '       <span class=pl-c># The parent component for a file tree, which builds a tree representation</span>',
        position: 2,
        left: 23,
        right: 23,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 24,
        text: '       # of the given diff and renders a collection of child components, where',
        html: '       <span class=pl-c># of the given diff and renders a collection of child components, where</span>',
        position: 3,
        left: 24,
        right: 24,
      },
      {
        type: 'DELETION',
        blobLineNumber: 25,
        text: '-      # each child is a PullRequest::FileTree::NodeComponent.',
        html: '-      <span class="pl-c"># each child is a <span class="x x-first x-last">PullRequest</span>::FileTree::NodeComponent.</span>',
        position: 4,
        left: 25,
        right: 24,
      },
      {
        type: 'ADDITION',
        blobLineNumber: 25,
        text: '+      # each child is a PullRequests::FileTree::NodeComponent.',
        html: '+      <span class="pl-c"># each child is a <span class="x x-first x-last">PullRequests</span>::FileTree::NodeComponent.</span>',
        position: 5,
        left: 25,
        right: 25,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 26,
        text: '       #',
        html: '       <span class=pl-c>#</span>',
        position: 6,
        left: 26,
        right: 26,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 27,
        text: '       # diff - An instance of GitHub::Diff',
        html: '       <span class=pl-c># diff - An instance of GitHub::Diff</span>',
        position: 7,
        left: 27,
        right: 27,
      },
      {
        type: 'CONTEXT',
        blobLineNumber: 28,
        text: '       # viewed_files (optional) - An instance of PullRequestUserReviews',
        html: '       <span class=pl-c># viewed_files (optional) - An instance of PullRequestUserReviews</span>',
        position: 8,
        left: 28,
        right: 28,
      },
    ],
    diffContext: 'pr',
    diffMatches: [],
    richDiff: {
      canToggleRichDiff: false,
      defaultToRichDiff: false,
      proseDiffHtml: undefined,
      renderInfo: undefined,
      dependencyDiffPath: undefined,
    },
    repository: {
      id: 1,
      name: 'smile',
      ownerLogin: 'monalisa',
    },
    pullRequest: {
      globalRelayId: '12345',
      subject: {
        isInMergeQueue: false,
        state: 'open',
      },
    },
    currentUser: {
      avatarURL: 'https://avatars.githubusercontent.com/u/1',
      login: 'monalisa',
      tabSize: 2,
      splitPreference: 'unified',
      lineSpacing: 'compact',
      canComment: true,
      commentsPreference: 'visible',
    },
    diffSize: '0 Bytes',
    isBinary: false,
    isTooBig: false,
    linesChanged: 2,
    newTreeEntry: {
      path: 'app/components/pull_requests/file_tree/root_component.rb',
      mode: 100644,
      lineCount: 60,
      isGenerated: false,
    },
    oldTreeEntry: {
      path: 'app/components/pull_requests/file_tree/root_component.rb',
      mode: 100644,
      lineCount: 60,
    },
    linesAdded: 1,
    linesDeleted: 1,
    path: 'app/components/pull_requests/file_tree/root_component.rb',
    pathDigest: 'b380a745f19cffd4e405d0b2fbac10a2245703d66a901df274d0a41cb1b6839b',
    status: 'MODIFIED',
    truncatedReason: null,
    oldCommitOid: '89c5109b75b889f2842d5692b8f3a260854e591d',
    newCommitOid: '482ea2f06a4bf6ff40295db68afe2a33d2d9a08b',
    helpUrl: 'https://help.github.com',
    objectId: 'some-object-id',
    commentingEnabled: false,
    changeType: 'MODIFIED',
  }

  return [mockDiff, mockDiff, mockDiff]
}
